import { useState } from "react";
import { MyReservationFilterWrapper } from "./styled";

interface MyReservationProps {
  filterList: number[];
  setValue: (value: number) => void;
  value: number;
  label: string;
}
const MyReservationFilter = ({
  filterList,
  setValue,
  value,
  label,
}: MyReservationProps) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <MyReservationFilterWrapper>
      <div className="label">
        <div className="text" onClick={() => setOpen(!open)}>
          {value}
          {label}
        </div>
        <img src="/image-web/Icon/Arrow%20down.svg" alt="arrow" />
      </div>
      {open && (
        <div className="filter-wrapper">
          {filterList.map((item, index) => (
            <div
              className={`filter-item ${value === item ? "select" : ""}`}
              key={index}
              onClick={() => {
                setValue(item);
                setOpen(false);
              }}
            >
              {item}
              {label}
            </div>
          ))}
        </div>
      )}
    </MyReservationFilterWrapper>
  );
};

export default MyReservationFilter;
